
import React, { useEffect, useState } from 'react';
import {
    Alert, Autocomplete, Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, Grid, IconButton, InputAdornment,
    InputBase, Paper, Snackbar, TextField,
    Typography
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { getUsuarios, getUsuariosCliente, postTarea } from '../../../services/apis';
import { useParams } from 'react-router-dom';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';

export const FormCrearTarea = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, opclientes, cargarTareas, opTrabajadores }) => {
    const handleClose = () => {
        setOpen(false);
    };

    const param = useParams();
    const [usuarioSelec, setUsuarioSelec] = useState({ label: "Seleccione un Usuario", value: "0" });
    const [opUsuarios, setOpUsuarios] = useState([]);
    const [enviando, setEnviando] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState([]);
    const [archivos, setArchivos] = useState([]);
    const [tarea, setTarea] = useState({
        'fecha': new Date(),
        'asunto': '',
        'descripcion': '',
        'localizacion': '',
        'id_cliente': null,
        'id_usuario': null,
        'minutos': '',
        'id_proyecto': param.id
    });

    const handleChange = (event) => {
        const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
        setTarea(tareaNueva);
        setErrorAlert(false)
    };


    const handleArchivoChange = (event) => {
        setArchivos((prevArchivos) => [
            ...prevArchivos,
            ...Array.from(event.target.files) // Agregar los nuevos archivos
        ]);
    };

    const isNullInObject = (obj) => {
        // Lista de campos que se deben omitir en la validación
        const camposExcepcion = ['localizacion', 'minutos', 'id_cliente', 'id_proyecto', 'trabajadores', 'id_usuario'];

        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };

    const crearTarea = async () => {
        const nuevaTareaTmp = { ...tarea };
        nuevaTareaTmp.id_cliente = clienteSelec.value;
        nuevaTareaTmp.id_usuario = usuarioSelec.value;

        nuevaTareaTmp.trabajadores = trabajadorSelec;

        const tareaComprobada = isNullInObject(nuevaTareaTmp);

        if (!tareaComprobada) {
            console.error("Hay campos vacíos o no válidos en la tarea");
            setErrorAlert(true);
            return; // Detener la ejecución si hay campos no válidos
        }

        try {

            const response = await postTarea(nuevaTareaTmp, archivos);
            if (response.success === true) {
                handleClose();

                cargarTareas();
                setTarea(
                    {
                        'fecha': new Date(),
                        'asunto': '',
                        'descripcion': '',
                        'localizacion': '',
                        'id_cliente': null,
                        'id_usuario': null,
                        'minutos': '',
                        'id_proyecto': param.id
                    });
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" });
                setArchivos(null)
                setTrabajadorSelec([]);
                handleClose();
                setEnviando(false);
            }
        } catch (error) {
            console.error("Error al cargar tareas", error);
        }
    };

    const handleSubmit = (e) => {
        setEnviando(true);
        e.preventDefault();
        crearTarea();
    };


    const eliminarArchivo = (index) => {
        const nuevosArchivos = archivos.filter((_, i) => i !== index);
        setArchivos(nuevosArchivos);
    };

    const cargarUsuarios = async (id) => {
        console.log(id);

        try {
            const response = await getUsuariosCliente(id);
            const tmp = [...response.data];
            const newTmp = tmp.map((item, index) => ({
                label: item.nombre,
                value: item.id
            }))
            setOpUsuarios(newTmp);
            console.log(newTmp);

        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    useEffect(() => {
        if (clienteSelec.value != "0") {
            cargarUsuarios(clienteSelec.value);
            setUsuarioSelec({ label: "Seleccione un Usuario", value: "0" });
        } else {
            setUsuarioSelec({ label: "Seleccione un Usuario", value: "0" });

        }
    }, [clienteSelec]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            maxWidth={'sm'}
            fullWidth={true}
        >
            <Backdrop
                sx={{ zIndex: 1000 }}
                open={enviando}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <DialogContent style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    gap={1}
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h6">
                        Nueva Solicitud de Ayuda
                    </Typography>

                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </Grid>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} direction="column">
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opclientes}
                                value={clienteSelec}
                                onChange={(event, newValue) => setClienteSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opUsuarios ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opUsuarios}
                                value={usuarioSelec}
                                onChange={(event, newValue) => setUsuarioSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>

                        <Grid item>
                            <Typography variant="subtitle1" sx={{ mb: -2 }}>
                                Asignar Empleado:
                            </Typography>
                            <AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Descripción"
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                name="descripcion"
                                value={tarea.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" component="label" sx={{ mt: 2 }}>
                            Subir Archivos
                            <input
                                type="file"
                                hidden
                                multiple
                                onChange={handleArchivoChange}
                            />
                        </Button>

                        {archivos && archivos.length > 0 && (
                            <div style={{ marginTop: '10px' }}>
                                {archivos && archivos.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        {archivos.map((archivo, index) => (
                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                <Button
                                                    onClick={() => eliminarArchivo(index)}
                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                >
                                                    X
                                                </Button>
                                                <span>{archivo.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </Grid>
                </form>
            </DialogContent>

            <DialogActions style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Crear Tarea
                </Button>
            </DialogActions>
            {errorAlert && (
                <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
            )}
        </Dialog>
    );
};
